import axios from 'axios';

export class NotifyEmailClient {
    /**
     * @param email
     * @param productId
     * @return {Promise<*>}
     */
    async send(email, productId) {
        const url = `save_notify_email.php`
        const response = await axios.post(url, {
            params: {
                email: email,
                prod_id: productId
            },
            responseType: 'text'
        });

        return response.data;
    }
}
